class CommonPopup extends HTMLElement {
  constructor() {
    super();

    this._open = this.open.bind(this);
    this._close = this.close.bind(this);
    this._onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.closeTigger = this.querySelector('[data-popup-close-tigger]');
  }

  attachListener() {
    this.closeTigger.addEventListener('click', this._close);
    document.addEventListener('keydown', this._onKeydown);
  }

  detachListener() {
    this.closeTigger.removeEventListener('click', this._close);
    document.removeEventListener('keydown', this._onKeydown);
  }

  open() {
    this.setAttribute('open', '');
    if (!this.focusableElements) {
      this.focusableElements = this.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
    }
    this.focusableElements[0]?.focus();
    this.attachListener();
  }

  close() {
    this.removeAttribute('open');
    this.detachListener();
  }

  onKeydown(e) {
    if (!this.hasAttribute('open')) return;

    // Esc
    if (e.key == 'Escape') {
      this.close();
    }

    // Tab
    const firstFocusable = this.focusableElements[0];
    const lastFocusable = this.focusableElements[this.focusableElements.length - 1];
    if (e.key == 'Tab') {
      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else { // Tab
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    }
  }
}

if (!customElements.get('common-popup')) {
  customElements.define('common-popup', CommonPopup);
}

export default CommonPopup;